import PropTypes from 'prop-types';
import React from 'react';
import { listTrackingPropType } from '../../utils/propTypes.js';
import { trackNonInteractiveEvent } from '../../utils/statistics/clientStatistics.js';
import { listInViewEvent, listViewedEvent } from '../../utils/statistics/nonInteractiveEvents.js';
import { createImageProxyUrl } from '../../utils/svtimage';
import useTrackViewing from '../../utils/useTrackViewing.js';
import { DisplayWindow, Heading, Placeholder, StyledRecommendations } from './Recommendations.styles';
import ContentItemCarousel, { CARD_TYPE } from '../../ui-components/ContentItemCarousel/ContentItemCarousel';

function getInViewTracker(listTracking) {
    if (listTracking) {
        return () => trackNonInteractiveEvent(listInViewEvent(listTracking));
    }

    // no op
    return () => {};
}

function getViewedTracker(listTracking) {
    if (listTracking) {
        return () => trackNonInteractiveEvent(listViewedEvent(listTracking));
    }

    // no op
    return () => {};
}

const RecommendationsContainer = ({ header, className, children, listTracking }) => {
    const [ref] = useTrackViewing(0.5, 1000, getInViewTracker(listTracking), getViewedTracker(listTracking));

    return (
        <StyledRecommendations
            className={className}
            ref={ref}
            data-helix-type="list"
            aria-label={header || 'Tips för dig'}
        >
            <Heading as="h1">{header || 'Tips för dig'}</Heading>
            {children}
        </StyledRecommendations>
    );
};

export const Loading = ({ className, header }) => (
    <RecommendationsContainer className={className} header={header}>
        {new Array(6).fill({ placeholder: true }).map((_item, index) => (
            <DisplayWindow key={`recommendation_loader_${index}`}>
                <Placeholder />
            </DisplayWindow>
        ))}
    </RecommendationsContainer>
);

const Recommendations = ({ items, header, className, onItemClick, listTracking }) => {
    if (!items || items.length === 0) {
        return null;
    }

    const mappedItems = items.map((item) => {
        const minSize = createImageProxyUrl(item.image.id, item.image.changed, 'wide', 300);
        const srcSet = `${minSize} 300w, ${createImageProxyUrl(
            item.image.id,
            item.image.changed,
            'wide',
            600
        )} 600w`;

        return {
            ...item,
            url: item.item.urls.svtplay,
            srcSet,
        };
    });

    return (
        <RecommendationsContainer header={header} listTracking={listTracking} className={className}>
            <ContentItemCarousel
                id="not-found-recommendations"
                items={mappedItems}
                editModeActivated={false}
                onItemClick={onItemClick}
                cardType={CARD_TYPE.SHOWCASE}
            />
        </RecommendationsContainer>
    );
};

Recommendations.propTypes = {
    items: PropTypes.array,
    header: PropTypes.string,

    className: PropTypes.string,
    listTracking: listTrackingPropType,
};

export default Recommendations;
